import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../../parts/SvgIcon";
import ToolTip from "../../../../../../parts/tooltip-portal";

const Notes = ({
  exerciseNotes,
  exerciseId,
  editDayMode,
  editable,
  handleInput,
}) => {
  const { t } = useTranslation("athlete-portal");
  return exerciseNotes || (editDayMode && editable) ? (
    <div
      className={`coach-note-container${
        editDayMode && !editable ? " not-editable" : ""
      }`}
    >
      <div className="coach-note">
        <SvgIcon src="/img/new-icons/message-icon.svg" alt="notes" />
        {!editDayMode ? (
          <p className="p4">{exerciseNotes}</p>
        ) : !editable ? (
          <ToolTip
            body={t("exerciseEditor.exerciseCompletedNoEdit")}
            forNotes={true}
            childrenContainerClass="tooltip-edit-mode"
          >
            <p className="p4">{exerciseNotes}</p>
          </ToolTip>
        ) : (
          <textarea
            id={`exercise-${exerciseId}-notes`}
            type="text"
            value={exerciseNotes}
            onChange={(evt) => {
              evt.preventDefault();
              handleInput({
                value: evt.target.value,
                field: "notes",
                exerciseId,
              });
            }}
            placeholder={t("exerciseEditor.enterNotePlaceholder")}
          />
        )}
      </div>
    </div>
  ) : (
    false
  );
};

export default Notes;
